import React, {Component} from 'react';
import axios from 'axios';
import { Form, FormGroup, Label, Button, Input, ListGroup, ListGroupItem, FormFeedback  } from 'reactstrap';
import Constants from '../inc/Constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhone} from '@fortawesome/pro-light-svg-icons/faPhone';
import { faGlobeEurope } from '@fortawesome/pro-light-svg-icons/faGlobeEurope';
import { faEnvelope} from '@fortawesome/pro-light-svg-icons/faEnvelope';
import { faHome } from '@fortawesome/pro-light-svg-icons/faHome';
import HeaderFooterHOC from '../HOC/HeaderFooterHOC';
import Swal from 'sweetalert2';
import LangContext from "../providers/LangContext";
import ReCAPTCHA from "react-google-recaptcha";

class Contact extends Component {

    static contextType = LangContext;

    constructor(props) {
        super(props);
        this.state = {
            name: '',
            email: '',
            phone: '',
            message: '',
            privacy: '',
            recaptcha: '',
            recapkey: 2,
            errors: { },
        };

        this.submit = this.submit.bind(this);
        this.inputChange = this.inputChange.bind(this);
        this.setRecapthaKey = this.setRecapthaKey.bind(this);

    }

    inputChange(e){
        let name = e.target.name;
        let value = e.target.value;
        let prevState = this.state;
        if(e.target.name === 'privacy') {
            const privacy = (prevState.privacy === 1) ? 0 : 1;
            this.setState({privacy: privacy});
        } else {
            prevState[name] = value;
            this.setState({...prevState});
        }
    }

    submit(e){
        const formData = {
            name: this.state.name,
            email: this.state.email,
            phone: this.state.phone,
            message: this.state.message,
            privacy: this.state.privacy,
            recaptcha: this.state.recaptcha
        };
        const self = this;

        axios({
            method: 'post',
            url: '/api/site/' + this.props.siteID + '/contact',
            data: formData,
        }).then(function (response) {
            Swal.fire({
                text: response.data.success,
                icon: 'success',
                timer: 3000
            }).then(() => {
                self.setState({
                    name: '',
                    email: '',
                    phone: '',
                    message: '',
                    privacy: false,
                    recaptcha: '',
                    recapkey: self.state.recapkey+1,
                })

            })
        }).catch(function (error) {
            self.setState(prevState => ({
                errors: error.response.data.errors
            }));
        });
    }

    setRecapthaKey(val) {
        this.setState({recaptcha: val});
    }

    render(){
        const visibleStyle = {display:'block'};
        const content = (this.props.page.page_content) ? this.props.page.page_content.page_content : '';
        let lang = this.context.lang;
        console.log(lang)
        return(
                    <div className="row">
                        <div className="col-md-8">

                            {this.props.theme === 'light' &&

                                <table cellPadding="5">
                                    <tr>
                                        <td colSpan="2"><strong>{this.props.customerName}</strong></td>
                                    </tr>
                                    <tr>
                                        <td>{lang.get('portal.address')}:</td>
                                        <td>{this.props.customerAddress}</td>
                                    </tr>
                                    <tr>
                                        <td>{lang.get('portal.phone')}:</td>
                                        <td><a href={'tel:' + this.props.customerPhone}>{this.props.customerPhone}</a></td>
                                    </tr>
                                    <tr>
                                        <td>{lang.get('portal.website')}:</td>
                                        <td><a
                                            href={'http://' + this.props.customerWebsite?.replace('http://', '')?.replace('https://', '')}
                                            target="_blank">{this.props.customerWebsite}</a></td>
                                    </tr>
                                    <tr>
                                        <td>{lang.get('portal.email')}:</td>
                                        <td><a href={'mailto:' + this.props.customerEmail}>{this.props.customerEmail}</a>
                                        </td>
                                    </tr>
                                </table>

                            }

                            <p dangerouslySetInnerHTML={{__html: content}} />
                            <Form className="contact_form">
                                <FormGroup>
                                    <Input invalid={ this.state.errors.name && !!this.state.errors.name } placeholder={lang.get('sites.your_name')} name="name" value={this.state.name} onChange={this.inputChange} />
                                    <FormFeedback>{ this.state.errors.name }</FormFeedback>
                                </FormGroup>

                                <FormGroup>
                                    <Input invalid={ this.state.errors.email && !!this.state.errors.email } placeholder={lang.get('sites.your_email_address')} type="email" name="email" value={this.state.email} onChange={this.inputChange} />
                                    <FormFeedback>{ this.state.errors.email }</FormFeedback>
                                </FormGroup>

                                <FormGroup>
                                    <Input invalid={ this.state.errors.phone && !!this.state.errors.phone } placeholder={lang.get('sites.your_phone_number')} name="phone" value={this.state.phone} onChange={this.inputChange} />
                                    <FormFeedback>{ this.state.errors.phone }</FormFeedback>
                                </FormGroup>

                                <FormGroup>
                                    <Input type="textarea" invalid={ this.state.errors.message && !!this.state.errors.message } rows="5" placeholder={lang.get('sites.your_message')} value={this.state.message} name="message" onChange={this.inputChange}  />
                                    <FormFeedback>{ this.state.errors.message }</FormFeedback>
                                </FormGroup>

                                <FormGroup className="mb-0" check>
                                    <Label check>
                                        <Input
                                          invalid={!!this.state.errors.privacy}
                                          type="checkbox"
                                          onChange={this.inputChange}
                                          value={this.state.privacy}
                                          name="privacy"
                                        />{' '}
                                        <p dangerouslySetInnerHTML={{__html: this.context.lang.get('sites.check_privacy_statement',{termsLink : this.props.terms}) }}/>
                                        <FormFeedback>{ this.state.errors.privacy }</FormFeedback>
                                    </Label>

                                </FormGroup>
                                <FormGroup className="">
                                    <ReCAPTCHA
                                        sitekey={Constants.RECAPTHCA_KEY.siteKey}
                                        onChange={this.setRecapthaKey}
                                        key={this.state.recapKey}
                                        theme={(this.props.theme === 'v1') ? 'dark' : 'light'}
                                    />
                                    {' '}{!!this.state.errors.recaptcha && <div className="invalid-feedback" style={visibleStyle}>{this.state.errors.recaptcha}</div>}
                                </FormGroup>

                                <Button color="primary" block={ this.props.theme !== 'light' ? true : false } onClick={this.submit} className="contact_btn">{lang.get('sites.send_message')}</Button>

                                <div className="d-block d-md-none mb-5"></div>

                            </Form>
                        </div>

                        { this.props.theme !== 'light' &&

                            <div className="col-md-4">

                                <h5>{ this.props.customerName }</h5>

                                <ListGroup className="mb-3 list-group-font">
                                    <ListGroupItem className="bg-transparent border-left-0 border-right-0"><FontAwesomeIcon icon={faPhone} /> <a href={'tel:' + this.props.customerPhone}>{ this.props.customerPhone }</a></ListGroupItem>
                                    <ListGroupItem className="bg-transparent border-left-0 border-right-0"><FontAwesomeIcon icon={faGlobeEurope} /> <a href={'http://' + this.props.customerWebsite?.replace('http://', '')?.replace('https://', '')} target="_blank"> { this.props.customerWebsite }</a></ListGroupItem>
                                    <ListGroupItem className="bg-transparent border-left-0 border-right-0"><FontAwesomeIcon icon={faEnvelope} /> <a href={'mailto:' + this.props.customerEmail}>{ this.props.customerEmail }</a></ListGroupItem>
                                    <ListGroupItem className="bg-transparent border-left-0 border-right-0"><FontAwesomeIcon icon={faHome} /> { this.props.customerAddress }</ListGroupItem>
                                </ListGroup>
                                <GoogleMapsStatic address={this.props.customerAddress}/>
                            </div>
                        }
                    </div>

        )
    }
}

export default HeaderFooterHOC(Contact);

const GoogleMapsStatic = (props) => {
    const {address} = props;
    return (<div>
        <a href={"https://www.google.com/maps/place/" + address} target="_blank">
            <img
                src={"https://maps.google.com/maps/api/staticmap?center=" + address + "&markers=" + address + "&zoom=15&size=375x225&sensor=false&key=AIzaSyDdZJYL6AiUDoF1zpUkTs5AmEFX3yc1pgU"}
                alt={address} className="rounded mx-auto d-block my-2 googlemaps_static"/>
        </a>
    </div>);
}
